import { ToggleCombinedProps } from './types';

const usePresenter = (props: ToggleCombinedProps): ToggleCombinedProps => {
  return props;
};

export default usePresenter;
